/**
 * Captures the raw location hash before anything else can read or mutate it.
 *
 * storeSlice's legacy UTM fallback (getUtmFromUrl) treats ANY non-empty hash
 * as a UTM tag in path/BrowserRouter mode and strips it from the URL via
 * history.replaceState the moment that module is evaluated — which happens
 * during the very first import of "./store", well before React mounts. A
 * deep link like #opensignup would be gone by the time any component effect
 * got a chance to look at window.location.hash.
 *
 * This module has no imports of its own, so as long as it is the FIRST
 * import in every entry point (main.tsx, embed.tsx) — before "./Root" and
 * anything that pulls in the store — it always wins that race and preserves
 * the original hash for whoever needs it (see Layout.tsx).
 */
export const initialHash: string =
  typeof window !== "undefined" ? window.location.hash : "";

let openSignupConsumed = false;

/**
 * Returns true exactly once per page load, the first time it is called and
 * only if the boot-time hash was "#opensignup".
 *
 * Needed because every page wraps its own <Layout /> instance rather than
 * sharing one persistent instance via <Outlet />, so Layout fully mounts and
 * unmounts on every navigation and a plain useEffect(() => {...}, []) check
 * against initialHash would re-fire — and re-open the modal — on every route
 * change, since initialHash itself never changes for the life of the page.
 */
export function consumeOpenSignupHash(): boolean {
  if (openSignupConsumed || initialHash !== "#opensignup") return false;
  openSignupConsumed = true;
  return true;
}
